import { defineComponent } from "vue";
import { BRAND_LOGO_PROFILES } from "@/utils/brandLogo";
export default defineComponent({
  name: "BrandLogo",
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: "Company logo"
    },
    profile: {
      type: String,
      default: "standard"
    },
    prepared: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoStyle() {
      const size = BRAND_LOGO_PROFILES[this.profile] || BRAND_LOGO_PROFILES.standard;
      const prepared = this.prepared || this.src.includes("-display-v1.png");
      return {
        width: `${size.width}px`,
        height: `${size.height}px`,
        maxWidth: "100%",
        objectFit: "contain",
        objectPosition: "center",
        borderRadius: "0",
        boxSizing: "border-box",
        padding: prepared ? "0" : this.profile === "avatar" ? "2px" : "6px",
        display: "block",
        flexShrink: "0"
      };
    }
  }
});